import { useQuery } from "@tanstack/react-query";
import $api from "../../api/axios";
import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import { reportErrorToSentry } from "../reportErrorToSentry/reportErrorToSentry";
import { AxiosError } from "axios";

type MeReturn = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  profileImageUrl?: string;
  entity: ERoleAccess;
  organizationId?: number;
  impersonatorId?: number;
  permissions?: "read-only" | "all";
};

export const useMe = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        const response = await $api.get<{ data: MeReturn }>("/me");
        return response.data.data;
      } catch (error) {
        const axiosError = error as AxiosError;
        reportErrorToSentry(axiosError, "useMe: /me");
        return {
          id: -1,
          email: "",
          firstName: "",
          lastName: "",
          profileImageUrl: "",
          entity: ERoleAccess.NONE
        };
      }
    }
  });

  const firstName = data?.firstName ?? "";
  const lastName = data?.lastName ?? "";
  const nameInitials = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`;
  const profileImageUrl = data?.profileImageUrl ?? "";

  return { data, isLoading, isError, derived: { nameInitials, profileImageUrl } };
};
